import React from 'react'
import { Link, useNavigate} from 'react-router-dom';

const PortfolioDetails = ({portfolioDetails}) => {
    const {subtitle,img} = portfolioDetails;
    const navigate = useNavigate();
  return (
    <div>
        <div className='text-center'>
            <h1 className='text-xl md:text-3xl font-medium text-[#22d3ee] mb-20 border-b-2 border-[#22d3ee] inline-block pb-2'>{subtitle}</h1>
            <img className='w-full' src={img} alt="Portfolio" />
            {/* <Link to={navigate(-1)} class="btn bg-transparent capitalize border-2 border-[#22d3ee] px-10 rounded-full mt-7 hover:bg-[#22d3ee] hover:text-white duration-500">Go to Portfolio</Link> */}
        </div>
    </div>
  )
}

export default PortfolioDetails